import { render, staticRenderFns } from "./pro-chiose-tree.vue?vue&type=template&id=5a90b04e";
import script from "./pro-chiose-tree.vue?vue&type=script&lang=jsx";
export * from "./pro-chiose-tree.vue?vue&type=script&lang=jsx";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;